import React, { useEffect, useState } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import Dropdown from '@deprecated-ui/calendar/Dropdown';
import styled from 'styled-components';

import Menu from './Menu/Menu';
import VerticalMenu from './Menu/VerticalMenu';
import { CALENDAR_MENU_ITEMS } from '../constants';
import { MoreMenu } from './Menu/styled';

const CalendarHeaderWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: 16px;
  background: ${color.light};
  border-radius: 3px;
  border: 1px solid ${color.gainsboro};
  overflow: hidden;
`;

const Header = styled.div`
  font-family: var(--bold-font);
  font-size: 16px;
  font-weight: 700;
  color: ${color.dimgray};
  padding: 13px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
/**
 * Set calendar title and active menu
 * @param {string} title - set header title
 * @param {string} activeMenu - set status active menu. available menu: Today', 'Economic',
 'Dividend', 'Stocksplit', 'Reverse Split', 'Right Issue', 'Warrant', 'Bonus', '
 Tender Offer', 'RUPS', 'Pubex ,'IPO',
 * @return {React.ReactNode} - Calendar Header.
 */
const CalendarHeader = ({
  title,
  activeMenu,
}: {
  title: string;
  activeMenu: string;
}) => {
  const [screenWidth, setScreenWidth] = useState<number>(0);

  useEffect(() => {
    const getDimension = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', getDimension);
    getDimension();
  }, []);

  return (
    <CalendarHeaderWrapper id="genhead">
      <Header>
        <div>Calendar - {title}</div>
        {screenWidth <= 1080 ? (
          <Dropdown
            overlay={
              <VerticalMenu
                selectedMenu={activeMenu}
                verticalMenuItems={CALENDAR_MENU_ITEMS}
              />
            }
            // @ts-expect-error
            style={{ order: 8 }}
          >
            <Flex align="center">
              <MoreMenu />
            </Flex>
          </Dropdown>
        ) : null}
      </Header>
      {screenWidth > 1080 ? <Menu activeMenu={activeMenu} /> : null}
    </CalendarHeaderWrapper>
  );
};

export default CalendarHeader;
